export default {
  PRIMARY: 'rgb(106, 194, 172)',
  PRIMARY_OPACITY: (opacity: number) => `rgb(106, 194, 172, ${ opacity })`,
}
